import { render } from "./NewsCalendarCard.vue?vue&type=template&id=54a47329&scoped=true"
import script from "./NewsCalendarCard.vue?vue&type=script&lang=js"
export * from "./NewsCalendarCard.vue?vue&type=script&lang=js"

import "./NewsCalendarCard.vue?vue&type=style&index=0&id=54a47329&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54a47329"

export default script